import { FiEdit } from "@react-icons/all-files/fi/FiEdit";
import { useContext } from 'react';
import TableTwoBody from "../../CommonComponent/BootstrapTable2Body/TableTwoBody";
import { AgentContext } from "../AgentComponent";

import { CgPassword } from "@react-icons/all-files/cg/CgPassword";
import { MdPayment } from "@react-icons/all-files/md/MdPayment";
import Avater from '../../../assets/images/avater.jpg';
import Auth from '../../../Utilities/Auth';
import NumberSeparator from '../../../Utilities/NumberSeparator';


function AgentTable({ data = [] }) {
    const user_detail = JSON.parse(Auth.header().userdetail)


    //Context
    const {
        setAgentEditModalShow,
        setGetSingleAgentData,
        setAddWalletModelShow,
        setChangePasswordModelShow
    } = useContext(AgentContext)

    const columns = [{
        dataField: 'id',
        text: 'SL',
        // sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '50px',
                textAlign: "center"
            };
        },
        style: {
            textAlign: "center"
        },
        formatter: (cell, row, rowIndex) => {
            return <>
                {rowIndex + 1}
            </>
        }
    }, {
        dataField: 'avatar',
        text: 'Image',
        // sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '45px',
                textAlign: "center"
            };
        },
        style: {
            textAlign: "center"
        },
        formatter: ((cell, row) => {
            return <>
                {cell != null ?

                    <img style={{ width: "45px", height: "45px", border: "1px solid #cccc", borderRadius: "50%" }} src={cell} alt={"no file"} className="img-fluid" /> :
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={Avater} style={{ width: "45px", height: "45px", border: "1px solid #cccc", borderRadius: "50%" }} alt="" />
                    </div>}
            </>
        })
    }, {
        dataField: 'id',
        text: 'ID',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '60px',
                textAlign: 'center'
            };
        },
        style: { textAlign: "center", verticalAlign: 'middle' },
        formatter: ((cell, row) => {
            return <>
                {row.id}
            </>
        })
    },
    {
        dataField: 'full_name',
        text: 'Name',
        sort: true,
        headerClasses: 'mobile-col-header',
        headerStyle: (colum, colIndex) => {
            return {
                width: '160px',
                textAlign: "center"

            };
        },
        style: { verticalAlign: 'middle', verticalAlign: 'middle' },
        formatter: ((cell, row) => {
            return <>
                {/* {cell + " (" + row.id + ")"} */}
                {cell}
            </>
        })
    },
    {
        dataField: 'collection_area_village',
        text: 'Village',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '100px',
                textAlign: "center"
            };
        },
        style: {
            textAlign: "center",
        },
        style: { textAlign: "center", verticalAlign: 'middle' },
        // formatter: (cell, row) => {
        //     return { cell }
        // }
    },
    {
        dataField: 'collection_area_police_station',
        text: 'P.S',
        // sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '80px',
                textAlign: "center"
            };
        },
        style: {
            textAlign: "center", verticalAlign: 'middle'
        },
    }, {
        dataField: 'collection_area_district',
        text: 'District',
        // sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '120px',
                textAlign: "center"
            };
        },
        style: {
            textAlign: "center", verticalAlign: 'middle'
        },
    },
    {
        dataField: 'mobile',
        text: 'Phone No.',
        // sort: false,
        headerStyle: (colum, colIndex) => {
            return {
                width: '100px',
                textAlign: "center"
            };
        },
        style: {
            textAlign: "center", verticalAlign: 'middle'
        },
    },
    {
        dataField: 'collection_area_village',
        text: 'Total Donor',
        // sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '100px',
                textAlign: "center"
            };
        },
        style: { textAlign: "center", verticalAlign: 'middle' },
        formatter: (cell, row) => {
            return row.members[0]?.total_member || 0
        }
    },
    {
        dataField: 'grade',
        text: 'Grade',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '60px',
                textAlign: 'center'
            };
        },
        style: { textAlign: "center", verticalAlign: 'middle' },
        formatter: ((cell, row) => {
            return <>
                {cell}
            </>
        })
    },
    // {
    //     dataField: 'collection_area_village',
    //     text: 'Village',
    //     sort: true,
    //     headerStyle: (colum, colIndex) => {
    //         return {
    //             width: '100px',
    //         };
    //     }
    // },
    // {
    //     dataField: 'total_wallet',
    //     text: 'Total wallet',
    //     sort: true,
    //     headerStyle: () => {
    //         return {
    //             width: '100px'
    //         }
    //     },
    //     formatter: (cell, row) => {
    //         return NumberSeparator.format(cell || 0)
    //     }
    // },
    //  {
    //     dataField: 'total_collection',
    //     text: 'Total collection',
    //     sort: true,
    //     headerStyle: () => {
    //         return {
    //             width: '100px'
    //         }
    //     },
    //     formatter: (cell, row) => {
    //         return NumberSeparator.format(cell || 0)
    //     }
    // }, 
    {
        dataField: 'balance',
        text: 'Balance',
        // sort: true,
        headerStyle: () => {
            return {
                width: '80px',
                textAlign: "center"
            }
        },
        style: {
            textAlign: "right", verticalAlign: 'middle'
        },
        formatter: (cell, row) => {
            return NumberSeparator.format(cell || 0)
        }
    }, {
        dataField: 'id',
        headerClasses: 'mobile-action-agent',
        text: 'Action',
        headerStyle: () => {
            return {

                textAlign: "center"
            }
        },
        style: { textAlign: "center" },
        formatter: ((cell, row) => {
            return <>
                {user_detail?.is_admin == "1" && <>
                    {/*Change Password*/}
                    <button title="Change Password"
                        className="btn btn-sm btn-info mx-1"
                        onClick={e => {
                            // data for update
                            setGetSingleAgentData(row)
                            // update modal show
                            setChangePasswordModelShow(true)
                        }
                        }>
                        Password
                    </button>
                    {/*Add Wallet*/}
                    <button title="WALLET"
                        className="btn btn-sm btn-success mx-1"
                        onClick={e => {
                            // data for update
                            setGetSingleAgentData(row)

                            // Add Wallet modal show
                            setAddWalletModelShow(true)

                        }
                        }>
                        Wallet
                    </button>
                </>}

                {/*edit Button*/}
                <button title="Edit"
                    className="btn btn-sm btn-warning mx-1"
                    onClick={e => {
                        // data for update
                        setGetSingleAgentData(row)
                        // update modal show
                        setAgentEditModalShow(true)
                    }
                    }>
                    Edit
                </button>


            </>
        })

    }

    ];


    return (
        <>
            <TableTwoBody
                is_pagination={false}
                products={data}
                columns={columns}
                isBorderd={true}
            />
        </>
    );
}

export default AgentTable;